import dayjs from 'dayjs'
import 'dayjs/locale/fr'

class DateUtils {
  static formatDate(dateString: string) {
    return dayjs(dateString).locale('fr').format('D MMMM YYYY')
  }

  static getYears(dateString: string) {
    return dayjs().diff(dayjs(dateString), 'year')
  }

  static convertEffectiveData(dateString: string) {
    if (!dateString) return
    const [days, time] = dateString.split('.')
    const [hours, minutes, seconds] = time.split(':')

    const totalHours =
      parseInt(days) * 24 + parseInt(hours) + parseInt(minutes) / 60 + parseInt(seconds) / 3600

    return totalHours
  }

  static convertTimeToSeconds(dateString: string) {
    const timeArray = dateString.split(':')
    const seconds = +timeArray[0] * 3600 + +timeArray[1] * 60 + +timeArray[2]
    return seconds
  }
}

export default DateUtils
